import type {z} from "zod";

import {ContactInputFields, PhoneNumberInput} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const contactInputFields = ContactInputFields.shape;

export const editClientContactNameSchema = requiredStringSchema(
  contactInputFields.name,
  contactFieldLabelIds.name,
);
export const editClientContactEmailSchema = contactInputFields.email.or(zod.literal(""));
export const editClientContactDescriptionSchema = contactInputFields.description;
export const editClientContactPhoneNumberSchema = PhoneNumberInput.shape.nationalNumber.optional();
export const editClientContactPhonePrefixSchema = PhoneNumberInput.shape.regionCode.optional();

const editClientContactFormFieldsSchema = zod.object({
  name: editClientContactNameSchema,
  description: editClientContactDescriptionSchema,
  email: editClientContactEmailSchema,
  phone: editClientContactPhoneNumberSchema,
  phonePrefix: editClientContactPhonePrefixSchema,
});

export const editClientContactFormSchema = editClientContactFormFieldsSchema.superRefine(
  (value, ctx) => {
    if (!value.email && !value.phone) {
      ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
    }
    if (value.phone && !value.phonePrefix) {
      ctx.addIssue({code: "custom", message: "Phone prefix is required", path: ["phonePrefix"]});
    }
  },
);
export type EditClientContactFormPayload = z.output<typeof editClientContactFormSchema>;

export const draftEditClientContactFormSchema = editClientContactFormFieldsSchema.partial();
export type DraftEditClientContactFormPayload = z.output<typeof draftEditClientContactFormSchema>;
